// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a.compliance[data-v-4ca7b902]{position:relative;margin-bottom:30px}a.compliance .compliance-text[data-v-4ca7b902]{position:absolute;left:50%;transform:translateX(-50%);bottom:-25px;color:#999;font-weight:400;font-family:\"Nunito Sans\",sans-serif;font-size:13px;font-weight:lighter}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
